import * as API from './'
import { partition } from 'lodash'

export default {
  //获取单个字段表项
  getDicByCategory: params => {
    return API.GET(process.env.baseSysURL + '/dic/queryByCategory', params)
  },
  //获取多个字段表项
  getMultiDicByCategory: params => {
    return API.POST(process.env.baseSysURL + '/dic/queryByCategoryList', params)
  },
  //根据区划代码查询区域信息
  getAdminAreaByQhdm: params => {
    return API.GET(process.env.baseSysURL + '/adminarea/getAdminAreaByQhdm', params)
  },
  //获取区划代码所有子集区域列表（不包括当前区域）
  getAllSubAdminAreaList: params => {
    return API.GET(process.env.baseSysURL + '/adminarea/getAllSubAdminAreaList', params)
  },
  //获取区划代码所有子集区域列表（包括当前区域）
  getCurrentAndAllSubAdminAreaList: params => {
    return API.GET(process.env.baseSysURL + '/adminarea/getCurrentAndAllSubAdminAreaList', params)
  },
  //返回下一级区域列表
  getNextSubAdminAreaList: params => {
    return API.GET(process.env.baseSysURL + '/adminarea/getNextSubAdminAreaList', params)
  },
  //返回下一级区域树
  getNextSubAdminAreaTree: params => {
    return API.GET(process.env.baseSysURL + '/adminarea/getNextSubAdminAreaTree', params)
  },
  //获取险种列表
  getDistinctXzList: params => {
    return API.GET(process.env.baseSysURL + '/xzdmb/getDistinctXzList', params)
  },
  //获取条款列表
  getDistinctTkList: params => {
    return API.GET(process.env.baseSysURL + '/xzdmb/getDistinctTkList', params)
  },
  //获取适用机构条款列表
  getSyjgTkList: params => {
    return API.GET(process.env.baseSysURL + '/xzdmb/getSyjgTkList', params)
  },
  //获取适用机构险种列表
  getSyjgXzList: params => {
    return API.GET(process.env.baseSysURL + '/xzdmb/getSyjgXzList', params)
  },
  /*获取行政区下拉框数据*/
  getXzqData(params) {
    return API.GET(process.env.BASESERVER + '/area/listAreaTree', params)
  },
  /*政策资讯获取行政区下拉框数据*/
  getSysAreaSubarea(params) {
    // return API.GET(process.env.BASICS + '/area/listAreaTree', params)
    return API.POST('https://nyapi.agribigdata.com.cn/gss-sys-server-api/api/v1/sys/area/subarea', params)
  },
  // 获取下级区划数据
  getSubArea(params) {
    return API.POST(process.env.baseSysURL + '/sys/area/subarea', params)
  },
  getDicCrops() {
    return API.POST(process.env.baseMachineryServer + '/dic/crop/list')
  },
  //获取评价信息数据
  getevaluateManahe(params) {
    // return API.POST('https://api.agribigdata.com.cn/gss-web-server-api/api/v1/comment/list', params)
    return API.POST(process.env.baseMachineryServer + '/comment/list', params)
  },
  getDetail(params) {
    // return API.GET('http://192.168.13.109:8089/gss-web-server-api-qh/api/v1/comment/getDetail', params)
    return API.GET(process.env.baseMachineryServer + '/comment/getDetail', params)
  }
}




// WEBPACK FOOTER //
// ./src/api/api_common.js